<template>
  <div class="more-card-container">
    <img :src="cover_url" alt="" class="cover" />
    <div class="content">
      <div class="tags">
        <Tag class="post-tag" v-for="tag in displayTags" :key="tag.id" :label="tag.name" />
      </div>
      <h3 class="title">{{ name }}</h3>
      <p class="description">{{ description }}</p>
      <NuxtLink :to="replaceRoutePath(route.path, path_url)" target="_blank" class="link">
        {{ $t('cha-kan-xiang-qing-learn') }}
        <ArrowRight class="text-[18px]"
      /></NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
import { type IRecommendCard } from '../types';
import Tag from './tag.vue';

const route = useRoute();

const props = defineProps<IRecommendCard>();

const displayTags = computed(() => {
  if (!props.tag_list || props.tag_list.length === 0) {
    return [];
  }

  // 容器宽度约为 336px (384 - 48px padding)
  // 每个标签预估宽度：文字长度 * 12px + 24px padding + 16px gap
  const containerWidth = 334;
  let currentWidth = 0;
  const result = [];

  for (const tag of props.tag_list) {
    // 预估标签宽度：中文字符约12px，英文字符约6px，padding约24px
    const estimatedWidth = tag.name.length * 16 + 24 + (result.length > 0 ? 16 : 0);

    if (currentWidth + estimatedWidth > containerWidth) {
      break;
    }

    result.push(tag);
    currentWidth += estimatedWidth;
  }

  return result;
});

// 替换路径中的最后一个 ID
const replaceRoutePath = (currentPath: string, pathUrl: string | number) => {
  const pathParts = currentPath.split('/');
  pathParts[pathParts.length - 1] = pathUrl.toString();
  return pathParts.join('/');
};
</script>

<style lang="scss" scoped>
.more-card-container {
  @apply flex-col justify-start;
  width: 384px;
  height: 520px;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    /* 投影 - 中 */
    box-shadow: 0 2px 20px 0 rgba(18, 25, 38, 0.1);
  }

  .cover {
    width: 100%;
    height: 216px;
    flex-shrink: 0;
    // max-height: 216px;
    object-fit: cover;
    // aspect-ratio: 16 / 9;
  }
  .content {
    @apply flex-col justify-between gap-4 p-6 pb-10;
    width: 100%;
    height: 100%;
    border-radius: 0 0 12px 12px;
    border-right: 1px solid var(--x-back-5);
    border-bottom: 1px solid var(--x-back-5);
    border-left: 1px solid var(--x-back-5);
    background: var(--x-back-1);
    overflow: hidden;
  }
  .tags {
    @apply flex justify-start items-start gap-4;
    height: 30px;
    .post-tag {
      flex-shrink: 0;
      background-color: var(--x-back-3);
    }
  }
  .title {
    color: var(--x-text-1);
    height: 56px;
    width: 100%;
    font-size: 20px;
    font-weight: 400;
    line-height: normal;
    margin: 0;
    display: -webkit-box; /* 必须配合 WebKitBox */
    -webkit-box-orient: vertical; /* 垂直排列子元素 */
    -webkit-line-clamp: 2; /* 限制行数，比如2行 */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .description {
    color: var(--x-text-5);
    height: 84px;
    margin: 0;
    color: var(--x-text-5);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 200% */
    display: -webkit-box; /* 必须配合 WebKitBox */
    -webkit-box-orient: vertical; /* 垂直排列子元素 */
    -webkit-line-clamp: 3; /* 限制行数，比如3行 */
    overflow: hidden; /* 超出隐藏 */
    text-overflow: ellipsis; /* 可加可不加，主要是兼容 */
  }
  .link {
    font-size: 16px;
    color: var(--x-purple-6);
    font-weight: 400;
    line-height: normal;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 8px;

    &:hover {
      color: var(--x-purple-8);
    }
  }
}
</style>
